import { Text } from '@fullstory/components';
import React, { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  AccessDeniedMessageSuggestionType,
  accessErrorMessageLong,
  noPermissionMessage,
  styledAccessDeniedMessage,
  styledCannedAccessDeniedMessage,
} from '../../utils/accessControlMessages';

interface AccessDeniedMessageProps {
  suggestion: AccessDeniedMessageSuggestionType;
  isCanned?: boolean;
  viewOnly?: boolean;
  accessError?: boolean;
}

export const AccessDeniedMessage: React.FC<AccessDeniedMessageProps> = ({
  suggestion,
  isCanned,
  viewOnly,
  accessError,
}) => {
  const intl = useIntl();

  if (accessError) return <>{accessErrorMessageLong}</>;
  if (viewOnly) return <FormattedMessage {...noPermissionMessage} />;

  return (
    <>
      {intl.formatMessage(isCanned ? styledCannedAccessDeniedMessage : styledAccessDeniedMessage, {
        suggestion,
        // eslint-disable-next-line react/display-name
        action: (actionText: ReactNode) => (
          <Text appearance="bodySmallBold" tag="span" color="inherit">
            {actionText}
          </Text>
        ),
      })}
    </>
  );
};

export const StyledAccessDeniedMessage: React.FC<AccessDeniedMessageProps> = props => (
  <Text appearance="bodySmall" tag="span" color="inherit">
    <AccessDeniedMessage {...props} />
  </Text>
);
